module.exports = __webpack_public_path__ + "static/media/flag-green.b8f07dbf.svg";